import { useEffect, useState, useRef } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { storeRequester } from "App";
import InputText from "components/inputs/InputText";
import Select from "react-select";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import ModalBase from "modals/base/ModalBase";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import style from "./ShippingInfoAddModal.module.css";
import { validateInputs } from "shared/utils/Utils";
import SuperExpressive from "super-expressive";
import P from "components/P";
import Center from "layouts/wrapper/Center";
import Radio from "components/inputs/radio/Radio";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import CustomButton from "components/buttons/CustomButton";
import { mobileNoFormat, textFormat } from "InitialData/regExp";
import { toast } from "react-toastify";

const ShippingInfoAddModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(100%, 800px)", "min(100%,540px)"];
  const withCloseButton = true;
  const clickOutsideToClose = false;
  const title = t("addShippingInfo");
  const buttonText = t("close");

  const modal = useRef();
  const inputs = useRef([]);
  const { setIsAdd, callback } = props;

  // const textFormat = {
  //   exp: SuperExpressive().startOfInput.caseInsensitive.oneOrMore.anyChar.endOfInput.toRegex(),
  //   description: "text format",
  //   sample: "빈칸 없어야 함",
  // };

  // 입력 필드들의 상태를 개별적으로 관리
  const [formData, setFormData] = useState({
    name: "",
    province: "",
    firstName: "",
    postalCode: "",
    address1: "",
    address2: "",
    phone: "",
    isDefault: false
  });

  const addressKrModalClick = () => {
    NiceModal.show("addressKr", { onCallback: addressKrCallback });
  };

  const addressKrCallback = (dataFromModal) => {
    if (dataFromModal) {
      setFormData(prev => ({
        ...prev,
        address1: dataFromModal.address,
        postalCode: dataFromModal.zonecode
      }));

      // ref를 통한 값 설정
      if (inputs.current[2]) inputs.current[2].setValue(dataFromModal.zonecode);
      if (inputs.current[3]) inputs.current[3].setValue(dataFromModal.address);
    }
  };

  const handleInputChange = (index, value) => {
    const fieldMap = {
      // 0: 'province',
      0: 'name',
      1: 'firstName',
      2: 'postalCode',
      3: 'address1',
      4: 'address2',
      5: 'phone',
      6: 'isDefault'
    };

    if (inputs.current[index]) {
      inputs.current[index].setValue(value);
    }

    setFormData(prev => ({
      ...prev,
      [fieldMap[index]]: value
    }));
  };

  const handleAddShippingAddress = async () => {
    const requiredFields = [0, 1, 2, 3, 4, 5];
    const isEmpty = requiredFields.some((index) => {
      const value = inputs.current && inputs.current[index]?.getValue()?.toString().trim();
      return !value;
    });

    if (isEmpty) {
      toast.error(t("배송지 정보를 모두 입력해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    const isDefault = inputs.current[6]?.getValue();
    const data = {
      address: {
        name: inputs.current[0]?.getValue()?.toString() || "",
        // province: inputs.current[0]?.getValue()?.toString() || "",
        first_name: inputs.current[1]?.getValue()?.toString() || "",
        last_name: "",
        postal_code: inputs.current[2]?.getValue()?.toString() || "",
        address_1: inputs.current[3]?.getValue()?.toString() || "",
        address_2: inputs.current[4]?.getValue()?.toString() || "",
        city: "city",
        country_code: "kr",
        phone: inputs.current[5]?.getValue()?.toString() || "",
        company: "default",
        metadata: { default: isDefault }
      },
    };

    try {
      const result = await storeRequester.addShippingAddress(data);
      modal.current?.close();
      setTimeout(() => {
        if (callback) {
          callback(result); // updateShippingAddress의 반환값 직접 사용
        }
        setIsAdd?.(prev => !prev);
      }, 100);

    } catch (error) {
      alert("배송지 수정 중 오류가 발생했습니다.");
    }
  };

  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
      overflow={"visible"}
    >
      <div style={{ padding: "20px" }}>
        <VerticalFlex gap={10}>
          <FlexChild padding={"0 0 10px 0"}>
            <Center width={"100%"} textAlign={"left"}>
              <P size={20} weight={"bold"}>
                {t("shippingInfoAdd")}
              </P>
            </Center>
          </FlexChild>
          <FlexChild>
            <div style={{ height: "1px", backgroundColor: "#dcdcdc" }} />
          </FlexChild>

          {/* 배송지명 */}
          <FlexChild>
            <HorizontalFlex gap={10} justifyContent={"flex-start"}>
              <FlexChild alignItems={"flex-start"} width={"20%"}>
                <P weight={"bold"} size={14}>
                  {t("배송지명")}
                </P>
              </FlexChild>
              <FlexChild alignItems={"flex-start"} width={"max-content"}>
                <InputText
                  ref={el => inputs.current[0] = el}
                  defaultValue={formData.name}
                  placeHolder={t("배송지명")}
                  regExp={[textFormat]}
                  onChangeValue={value => handleInputChange(0, value)}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>

          {/* 이름 */}
          <FlexChild>
            <HorizontalFlex justifyContent={"flex-start"} gap={10}>
              <FlexChild width={"20%"}>
                <P weight={"bold"} size={14}>
                  {t("name")}
                </P>
              </FlexChild>
              <FlexChild width={"39%"}>
                <InputText
                  ref={el => inputs.current[1] = el}
                  defaultValue={formData.firstName}
                  placeHolder={t("name")}
                  regExp={[textFormat]}
                  onChangeValue={value => handleInputChange(1, value)}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>

          {/* 주소 */}
          <FlexChild>
            <HorizontalFlex justifyContent={"flex-start"} gap={10}>
              <FlexChild width={"20%"}>
                <P weight={"bold"} size={14}>
                  {t("address")}
                </P>
              </FlexChild>
              <FlexChild>
                <VerticalFlex gap={10} flexStart>
                  <FlexChild width={"60%"}>
                    <HorizontalFlex gap={20}>
                      <FlexChild>
                        <InputText
                          ref={el => inputs.current[2] = el}
                          defaultValue={formData.postalCode}
                          readOnly
                          placeHolder={t("우편번호")}
                          regExp={[textFormat]}
                        />
                      </FlexChild>
                      <FlexChild>
                        <button
                          style={{
                            border: "1px solid lightgray",
                            padding: "5px 10px",
                            borderRadius: "3px",
                          }}
                          onClick={addressKrModalClick}
                        >
                          우편번호 찾기
                        </button>
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                  <FlexChild>
                    <HorizontalFlex gap={10}>
                      <FlexChild>
                        <InputText
                          ref={el => inputs.current[3] = el}
                          defaultValue={formData.address1}
                          placeHolder={t("주소를 검색해주세요.")}
                          readOnly
                          regExp={[textFormat]}
                        />
                      </FlexChild>
                      <FlexChild>
                        <InputText
                          ref={el => inputs.current[4] = el}
                          defaultValue={formData.address2}
                          placeHolder={t("상세주소를 입력해주세요 .")}
                          regExp={[textFormat]}
                          onChangeValue={value => handleInputChange(4, value)}
                        />
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>

          {/* 전화번호 */}
          <FlexChild>
            <HorizontalFlex justifyContent={"flex-start"} gap={10}>
              <FlexChild width={"20%"}>
                <P weight={"bold"} size={14}>
                  {t("number")}
                </P>
              </FlexChild>
              <FlexChild>
                <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                  <FlexChild width={"49%"}>
                    <InputText
                      ref={el => inputs.current[5] = el}
                      defaultValue={formData.phone}
                      placeHolder={t("enterPhoneNumber")}
                      regExp={[mobileNoFormat]}
                      feedback="올바른 번호를 입력해주세요"
                      onChangeValue={value => handleInputChange(5, value)}
                    />
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <CheckCircle
              ref={(el) => (inputs.current[6] = el)}
              label={t("saveAsDefaultShippingInfo")}
              defaultChecked={formData.isDefault}
            />
          </FlexChild>
        </VerticalFlex>

        {/* 등록 버튼 */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "50px",
          }}
        >
          <button
            onClick={handleAddShippingAddress}
            style={{
              backgroundColor: "#296AFF",
              border: "none",
              padding: "10px 20px",
              width: "100%",
              borderRadius: "3px",
              color: "white",
            }}
          >
            <p style={{ fontSize: "16px", fontWeight: "bold" }}>
              신규 주소 추가
            </p>
          </button>
        </div>
      </div>
    </ModalBase>
  );
});

export default ShippingInfoAddModal;